import Component from 'inferno-component';
import Page from '../components/Page';
import '../assets/styles/index.css';

class Resources extends Component {
  render() {
    return (
      <Page title="Resources">
        <div className="about__container">
          <h2 className="about__header">Paena Pūnaewele No Nā Kumu ʻIke Hawaiʻi</h2>
          <h3 className="about__header">Online Sites for Hawaiian Content Resources</h3>
          <div className="about__body">
            <p>
              <ul>
                <li>
                  Hawaiian Language Dictionary<br />
                  <a href="http://www.wehewehe.org">www.wehewehe.org</a>
                </li>
                <li>
                  Ulukau online Hawaiian library - Hawaiian and English texts<br />
                  <a href="http://www.ulukau.org">www.ulukau.org</a>
                </li>
                <li>
                  OHA's Knowledge Well, a collection of various Hawaiian collections<br />
                  <a href="http://www.papakilodatabase.com">www.papakilodatabase.com</a>
                </li>
                <li>
                  Hawaiian National Bibliographies, Vol. 1-4<br />
                  <a href="http://www.papakilodatabase.com/main/sourcesearch.php">www.papakilodatabase.com/main/sourcesearch.php</a>
                </li>
                <li>
                  Hoʻolaupaʻi: Hawaiian Language Newspaper Project<br />
                  <a href="http://www.nupepa.org">www.nupepa.org</a>
                </li>
                <li>
                  A forum for articles from the newspapers with translations<br />
                  <a href="http://www.nupepa-hawaii.com">www.nupepa-hawaii.com</a>
                </li>
                <li>
                  Hawaiʻi State Archives Online collections<br />
                <a href="https://digitalcollections.hawaii.gov/greenstone3/library">https://digitalcollections.hawaii.gov/greenstone3/library</a>
                </li>
                <li>
                  Hawaiian Historical Societies online collection<br />
                  <a href="http://www.hawaiianhistory.org">www.hawaiianhistory.org</a>
                </li>
                <li>
                  Hawaiian language newspapers and Science<br />
                  <a href="http://manoa.hawaii.edu/kahuaao/">http://manoa.hawaii.edu/kahuaao</a>
                </li>
                <li>
                  Hawaiian Mission Houses Historical Site and Archive, online collection<br />
                  <a href="https://hmha.missionhouses.org/collection-tree">https://hmha.missionhouses.org/collection-tree</a>
                </li>
                <li>
                  Kipuka. Geographical information System utilizing mapping technology<br />
                  <a href="http://www.kipukadatabase.com">www.kipukadatabase.com</a>
                </li>
                <li>
                  Hawaiian language newspaper articles, fishing and natural events<br />
                  <a href="http://ihlrt.seagrant.soest.hawaii.edu">http://ihlrt.seagrant.soest.hawaii.edu</a>
                </li>
                <li>
                  Bishop Museumʻs online collection of curriculum support materials<br />
                  <a href="http://hawaiialive.org">http://hawaiialive.org</a>
                </li>
                <li>
                  Huapala Hawaiian Music and Hula Archives<br />
                  <a href="http://www.huapala.org">www.huapala.org</a>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </Page>
    );
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/pages/Resources.js